// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterAddress_root__R_zgq","title":"FooterAddress_title__vT_TL","country":"FooterAddress_country__cdBLy"};